import { TitleInput } from "./titleInput";
import { StandardButton } from "../atoms/buttons";
import { useEffect, useState, useContext, useCallback } from "react";
import { fetchAPI, postAPI } from "../api/api";
import { PageContext, UserContext } from "../App";
import { Modal, ModalTitle, ModalBody } from "../components/modal";
import { HorizontalLayout, VerticalLayout } from "./layout";
import { SettingHeader } from "../molecule/SettingHeader";
import { Alert } from "./alert";
import { SettingsHeader } from "../molecule/settingsHeader";

export function ProfileSetting() {
  const { sidebar: { userId: selectedUserId } } = useContext(PageContext);
  const userContext = useContext(UserContext);
  
  const userId = "@me";

  const [userData, setUserData] = useState({
    firstName: "", lastName: "", email: "", phone: "", description: "",
  });
  
  const [modalState, setModalState] = useState({
    isVisible: false, success: false, error: false,
  });
  const placeholders = {
    firstName: "Voer je voornaam in",
    lastName: "Voer je achternaam in",
    email: "Voer je e-mailadres in",
    phone: "Voer je telefoonnummer in",
    description: "Beschrijf wie je bent en wat je doet",
  };
  const handleInput = (field) => (e) => setUserData((prev) => ({ ...prev, [field]: e.target.value }));
  const loadData = useCallback(async () => {
    try {
      const { details = {} } = await fetchAPI(`api/users/${userId}`);
      setUserData({
        firstName: details.first_name || "", lastName: details.last_name || "",
        email: details.email || "", phone: details.phone_number || "", description: details.user_description || "",
      });
    } catch (error) {
      console.error("Failed to load user data", error);
    }
  }, [userId]);
  useEffect(() => { loadData(); }, [loadData]);
  const setModalStateTimeout = (state, delay = 1500) => setTimeout(() => setModalState((prev) => ({ ...prev, [state]: false })), delay);
  const saveData = useCallback(async () => {
    try {
      const response = await postAPI("api/users/update", {
        first_name: userData.firstName, last_name: userData.lastName,
        email: userData.email, phone_number: userData.phone, user_description: userData.description,
      });
      setModalState({ success: response.status === "ok", error: response.status !== "ok", isVisible: false });
      setModalStateTimeout(response.status === "ok" ? "success" : "error");
      loadData()
    } catch (error) {
      console.error("Failed to save data", error);
      setModalState({ error: true, isVisible: false });
      setModalStateTimeout("error");
    }
  }, [userData]);
  const inputFields = [
    { title: "Voornaam", value: userData.firstName, placeholder: placeholders.firstName, field: "firstName" },
    { title: "Achternaam", value: userData.lastName, placeholder: placeholders.lastName, field: "lastName" },
    { title: "Email", value: userData.email, placeholder: placeholders.email, field: "email", disabled: true },
    { title: "Telefoon", value: userData.phone, placeholder: placeholders.phone, field: "phone", typeInput: "tel" },
    { title: "Beschrijving", value: userData.description, placeholder: placeholders.description, field: "description", typeInput: "area" },
  ];
  const ModalMessage = ({ isVisible, title, message, onDismiss, onSave, isConfirmationModal }) => (
    <Modal size="small" visible={isVisible} dismissable={onDismiss} content={
      <>
        <ModalTitle title={title} hasXmark={false} dismissable={onDismiss} />
        <ModalBody>
          <p>{message}</p>
          {isConfirmationModal && (
            <HorizontalLayout className="space-between">
              <StandardButton title="Ja, opslaan" onClick={() => { onSave(); onDismiss(); }} style={{ marginLeft: 0 }} />
              <StandardButton title="Annuleren" onClick={onDismiss} />
            </HorizontalLayout>
          )}
        </ModalBody>
      </>
    } />
  );
  const modals = [
    { condition: modalState.isVisible, title: "Weet je zeker dat je de wijzigingen wilt opslaan?", onDismiss: () => { loadData(); setModalState({ isVisible: false }); }, onSave: saveData, isConfirmationModal: true },
    { condition: modalState.success, title: "Gegevens succesvol opgeslagen!", message: "Je profiel is met succes bijgewerkt.", onDismiss: () => setModalState({ success: false }), isConfirmationModal: false },
    { condition: modalState.error, title: "Er is een fout opgetreden", message: "Er is een probleem opgetreden bij het opslaan van je gegevens.", onDismiss: () => setModalState({ error: false }), isConfirmationModal: false },
  ];

  return (
    <VerticalLayout className="settings-card">
      
      <SettingsHeader
        button={false}
        title={"Profiel"}
        description={"Je profiel en persoonlijke gegevens."}
      />
      { !userContext.permissions.includes("settings.profile.manage") && <Alert marginLeft={"1rem"} marginRight={"1rem"} type="error" message="Uw bedrijf staat geen profielswijzigingen toe, of beheert deze namens u. Als u deze toch wilt aanpassen, neem dan contact op met uw beheerder." /> }
      <VerticalLayout className="profile-input settings-comp">
        {inputFields.map(({ title, value, placeholder, field, typeInput = "text", disabled = !userContext.permissions.includes("settings.profile.manage") }) => (
          <TitleInput key={field} title={title} value={value} placeholder={placeholder} typeInput={typeInput} disabled={disabled} onChange={handleInput(field)} />
        ))}
        { userContext.permissions.includes("settings.profile.manage") &&  <StandardButton title="Opslaan" onClick={() => setModalState({ ...modalState, isVisible: true })} /> }
      </VerticalLayout>
      {modals.map(({ condition, title, message, onDismiss, onSave, isConfirmationModal }, index) => condition && (
        <ModalMessage key={index} isVisible={condition} title={title} message={message} onDismiss={onDismiss} onSave={onSave} isConfirmationModal={isConfirmationModal} />
      ))}
    </VerticalLayout>
  );
}
